import React from 'react';
;
import { Card, CardContent, Tabs, TabList, TabLink, Tab } from 'src/ui/mui-ui-kit';
import { Form } from 'react-final-form';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withNavigation } from 'src/ui/hoc';
import arrayMutators from 'final-form-arrays';
import { toast } from 'react-toastify';
import createCalculator from 'final-form-calculate';
import {
  InnerLoader,
  SaveChangesToast,
  reduceServerErrors,
  UiToastAdapter,
} from 'src/ui';
import { getUser } from 'src/user';
import { AccountDataForm, AddAccountModal } from '../components';
import {
  getFormData,
  fetchFormData,
  sendAccountInvite,
  transformInvite,
} from '../redux';
// import { INFORMATION_NEEDED_TOGGLES } from '../const';

const tabs = [
  {
    label: 'Account',
    key: 'account',
    component: AccountDataForm,
  },
];

class AccountAddPage extends React.Component {
  state = {
    activeTab: tabs[0].key,
    hiddenTab: null,
    loading: true,
    inviteModal: false,
    initialValues: {},
  };

  constructor() {
    super();

    this.formCalculator = createCalculator();
  }

  async componentDidMount() {
    const { fetchFormData, user } = this.props;

    await Promise.all([
      fetchFormData(user.financialInstitutionId),
      // fetchPaymentProducts(),
    ]);
    this.setInitialValues();

    this.setState({ loading: false });
  }

  setInitialValues() {
    const { user } = this.props;
    const initialValues = {
      bankingService: user.financialInstitutionForBanking,
      paymentService: user.financialInstitutionForPayments,
      lendingService: user.financialInstitutionForLending,
      insuranceService: user.financialInstitutionForInsurance,

      pricingFormat: 'PIN-Debit IC+ Pass Through',
      processingType: 'Retail',
      pciMonthlyProgramFee: '10.00',
      chargeBackFee: '20.00',
      monthlyMinimumFee: '50.00',
      retrievalFee: '20.00',
      returnFee: '20.00',
      batchCloseFee: '0.35',
      terminalIdFee: '2.00',
      monthlyStatementFee: '10.00',
      onlinePortalFee: '10.00',
      pciNonComplianceFee: '30.00',
      achRejectFee: '20.00',
    };
    this.setState({ initialValues });
  }

  onSubmit = async values => {
    const { user, sendAccountInvite } = this.props;

    this.hideModal();

    const result = await sendAccountInvite({
      financialInstitutionId: user.financialInstitutionId,
      ...values,
      ownerFirstName: values.firstName,
      ownerLastName: values.lastName,
      ownerMobilePhone: values.phoneNumber,
      ownerEmail: values.emailAddress,
      forBanking: values.bankingService,
      forPayments: values.paymentService,
      forLending: values.lendingService,
      forInsurance: values.insuranceService,
      servicesOffered: (values.servicesOffered || []).map(
        service => service.id
      ),
    });

    const isError = result.error;

    if (isError) {
      const errorData = transformInvite(result.payload.response);

      return reduceServerErrors({
        error: {
          body: { ...errorData, detail: 'Error sending account invite.' },
        },
      });
    }

    const { history } = this.props;
    toast(UiToastAdapter('Account created successfully!', 'success'));
    history.push('/accounts');
    return undefined;
  };

  setActiveTab(activeTab = tabs[0].key) {
    this.setState({ activeTab });
  }

  hideModal = () => {
    this.setState({ inviteModal: false });
  };

  showModal = () => {
    this.setState({ inviteModal: true });
  };

  render() {
    const { isExpanded, user, formData } = this.props;
    const {
      activeTab,
      hiddenTab,
      loading,
      inviteModal,
      initialValues,
    } = this.state;
    const {
      financialInstitutionForBanking,
      financialInstitutionForPayments,
      financialInstitutionForLending,
      financialInstitutionForInsurance,
    } = user;

    const toastContainerClassName = classNames('bottom-toast-container', {
      'is-condensed': !isExpanded,
    });

    return (
      <div className="account-add-page ui-tabbed-intro">
        <Card className="intro">
          <CardContent>
            <h2 className="has-text-info has-text-weight-semibold is-size-5">
              Create Account
            </h2>
            <Tabs isToggle>
              <TabList>
                {tabs.map(tab => (
                  <Tab
                    isActive={tab.key === activeTab}
                    key={tab.key}
                    className={tab.key === hiddenTab ? 'is-hidden' : ''}
                  >
                    <TabLink onClick={() => this.setActiveTab(tab.key)}>
                      {tab.label}
                    </TabLink>
                  </Tab>
                ))}
              </TabList>
            </Tabs>
          </CardContent>
        </Card>

        <Form
          onSubmit={this.onSubmit}
          mutators={{
            ...arrayMutators,
          }}
          decorators={[this.formCalculator]}
          initialValues={initialValues}
          subscription={{
            submitting: true,
            hasValidationErrors: true,
            dirty: true,
            dirtySinceLastSubmit: true,
            values: {
              firstName: true,
              lastName: true,
              emailAddres: true,
            },
          }}
          render={({
            handleSubmit,
            submitting,
            hasValidationErrors,
            dirty,
            dirtySinceLastSubmit,
            values,
          }) => (
            <form onSubmit={handleSubmit}>
              <InnerLoader visible={submitting || loading} />
              <div className={toastContainerClassName}>
                <SaveChangesToast
                  message="Click the button to the right to proceed with the invitation"
                  isLoading={submitting}
                  isDisabled={submitting || hasValidationErrors}
                  isVisible={dirty || dirtySinceLastSubmit}
                  onClickButton={this.showModal}
                />
              </div>
              {tabs.map(({ key, component: TabComponent }) => {
                const className = key === activeTab ? '' : 'is-hidden';

                return (
                  <Card className={className} key={key}>
                    <CardContent>
                      <TabComponent
                        allowsBanking={financialInstitutionForBanking}
                        allowsPayment={financialInstitutionForPayments}
                        allowsLending={financialInstitutionForLending}
                        allowsInsurance={financialInstitutionForInsurance}
                        values={values}
                        formData={formData}
                      />
                    </CardContent>
                  </Card>
                );
              })}
              <AddAccountModal
                values={values}
                onCancel={this.hideModal}
                isActive={inviteModal}
              />
            </form>
          )}
        />
      </div>
    );
  }
}

AccountAddPage.propTypes = {
  history: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
  user: propTypes.object.isRequired,
  formData: propTypes.object.isRequired,
  fetchFormData: propTypes.func.isRequired,
  sendAccountInvite: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    formData: getFormData(state),
  };
}

const connectedAccountAddPage = connect(mapStateToProps, {
  fetchFormData,
  sendAccountInvite,
})(withNavigation(AccountAddPage));

export { connectedAccountAddPage as AccountAddPage };
